<template>
  <div class="w1200 newsBox">
    <div class="leftBox">
      <div class="bannerBox">
        <Banner />
      </div>
      <div>
        <Firstcolumn :columnlist="columnlist" :initdata="newsIinitData.content.listMapData" :alldata="newsIinitData" />
      </div>
    </div>
    <div class="rightBox">
      <Rightlist />
    </div>
  </div>
</template>
<script>
import Banner from '@/components/banner_smoll'
import Firstcolumn from '@/views/firstlist/firstcolumn_news'
import Rightlist from '@/components/commonRightList'
export default {
  components: { Banner, Firstcolumn, Rightlist },
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '按照标签查看-',
      mateDesc: metaStr
    }
  },
  computed: {
    columnlist() {
      var arrs = this.$store.state.newsData.contentTypes
      if (arrs) {
        if (arrs[0].value !== '') {
          arrs.unshift({ 'value': '', 'name': '全部' })
        }
      }
      return arrs
    },

    newsIinitData() {
      return this.$store.state.newsData
    }
  },
  asyncData({ store, route }) {
    return store.dispatch('getNewsInitData', { templateId: route.params.templateId })
  },
  created() {

  },
  mounted() {

  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .newsBox{
        background-color: #fafafa;
        overflow: hidden;
        position: relative;
    }
    .leftBox{
        width: 880px;
        margin-right: 20px;
        margin-top: 20px;
        float: left;
        .bannerBox{
            width: 880px;
            height: 340px;
        }

    }
    .rightBox{
        width: 300px;
        /*margin-left: 20px;*/
        margin-top: 20px;
        float: right;
        /*top: 0;*/
        /*right: 0;*/
        overflow: hidden;
    }
</style>

